import React from "react";
import TextField from "@mui/material/TextField";

export default function Textfield(props) {
  const { label, description, inputFromUser, value, identifier, id } = props;

  const handleChange = (e) => {
    inputFromUser(identifier, e.target.value);
  };
  return (
    <div className="inputDiv " id={id}>
      <TextField
        id="outlined-basic"
        sx={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          margin: "0px 13px",
        }}
        label={label}
        size="small"
        // value={value}
        onChange={handleChange}
        InputLabelProps={{
          className: "floatingLabelFocusStyle",
        }}
      />
      <p className="inputDescription">{description}</p>
    </div>
  );
}
